export { authenticate, checkLoginStatus } from "./auth";
export { getTables, addTables, updateTables, removeTables } from "./tables";
export {
	getReservations,
	addReservations,
	updateReservations,
	removeReservations
} from "./reservations";
//export { getSettings, saveSettings } from "./settings";
export { loadInitialData } from "./setup";
//export { updateOnStoreChange } from "./auto-update";
